<template>
  <div class="yulan-info" :class="$route.query.themeStyleVs == 2 ? 'black_theme' : 'white_theme'">
    <div v-if="!is304">
      <div class="header-bg">
        <van-sticky z-index="100">
          <div
            class="content-nav-bar"
            :class="bodyOffsetTop <= contentNavBar ? 'sticky-header' : ''"
            :style="`backdrop-filter: blur(${filterNum}px)`"
          >
            <van-nav-bar title="量化回测预览">
              <template #left>
                <van-icon name="cross" size="18" @click="close" />
              </template>
            </van-nav-bar>
          </div>
        </van-sticky>

        <div class="yulan-content" v-if="queryResult">
          <div class="header">
            <div class="title">
              <p class="name">回测结果预览</p>
            </div>
          </div>

          <div class="collapse">
            <p class="title" @click="handleClickShowAll">
              · 因子池内容
              <span v-if="checkedYzList.length > 2">
                <van-icon name="arrow-down" v-if="num === 2" />
                <van-icon name="arrow-up" v-else />
              </span>
            </p>
            <div class="yz-list">
              <van-row gutter="8">
                <template v-for="(item, index) in checkedYzList">
                  <van-col
                    span="12"
                    :key="index"
                    v-if="index < num"
                    :class="'showParameterAll_animation'"
                  >
                    <p class="li">{{ item.FactorName }}</p>
                  </van-col>
                </template>
              </van-row>
            </div>
          </div>

          <div class="collapse">
            <p class="title" @click="handleClickShowParameterAll">
              · 交易参数
              <span>
                <van-icon name="arrow-down" v-if="isShowParameterAll == false" />
                <van-icon name="arrow-up" v-else />
              </span>
            </p>
            <div class="yz-list parameter">
              <van-row gutter="8">
                <van-col span="24" class="showParameterAll_animation">
                  <div class="li">
                    <p class="par-classify">基础</p>

                    <ul class="par-ul">
                      <li class="par-ul_li">
                        <p class="par-ul_label">初始化资金</p>

                        <p class="par-ul_content" v-if="Obj">{{ Obj.startMoney || '--' }}元</p>
                      </li>

                      <li class="par-ul_li">
                        <p class="par-ul_label">持股上限</p>

                        <p class="par-ul_content" v-if="Obj">{{ Obj.PositionLimit || '--' }}只</p>
                      </li>
                    </ul>
                  </div>
                </van-col>

                <van-col
                  span="24"
                  v-show="isShowParameterAll"
                  :class="isShowParameterAll ? 'showParameterAll_animation' : ''"
                >
                  <div class="li">
                    <p class="par-classify">买入</p>

                    <ul class="par-ul">
                      <li class="par-ul_li">
                        <p class="par-ul_label">买入时机</p>

                        <p class="par-ul_content">次日开盘买入</p>
                      </li>

                      <li class="par-ul_li">
                        <p class="par-ul_label">单日买入</p>

                        <p class="par-ul_content" v-if="Obj">{{ Obj.buyLimit || '--' }}只</p>
                      </li>

                      <li class="par-ul_li">
                        <p class="par-ul_label">买入顺序</p>

                        <p class="par-ul_content">
                          <span v-if="Obj && Obj.sortKind == 0">成交额</span>
                          <span v-if="Obj && Obj.sortKind == 1">涨跌幅</span>
                          <span v-if="Obj && Obj.sortKind == 2">换手率</span>
                          <span v-if="Obj && Obj.sortKind == 3">量比</span>
                          <span v-if="Obj && Obj.sortKind == 4">总市值</span>
                          <span v-if="Obj && Obj.sortKind == 5">流通市值</span>
                          <span v-if="Obj && Obj.sortKind == 6">市盈率TTM</span>
                          <span v-if="Obj && Obj.sortKind == 7">振幅</span>
                          <span v-if="Obj && Obj.sortDirection == 0">从大到小</span>
                          <span v-if="Obj && Obj.sortDirection == 1">从小到大</span>
                        </p>
                      </li>
                    </ul>
                  </div>
                </van-col>

                <van-col
                  span="24"
                  v-show="isShowParameterAll"
                  :class="isShowParameterAll ? 'showParameterAll_animation' : ''"
                >
                  <div class="li">
                    <p class="par-classify">卖出</p>

                    <ul class="par-ul">
                      <li class="par-ul_li">
                        <p class="par-ul_label">策略止盈</p>

                        <p class="par-ul_content" v-if="Obj">
                          收益率 ≥ {{ (Obj.stopProfitHigh * 100).toFixed(2) || '--' }}% 时回落{{
                            (Obj.stopProfitLow * 100).toFixed(2) || '--'
                          }}%
                        </p>
                      </li>

                      <li class="par-ul_li">
                        <p class="par-ul_label">策略止损</p>

                        <p class="par-ul_content" v-if="Obj">
                          收益率 ≤ {{ (Obj.stopLoss * 100).toFixed(2) || '--' }}%
                        </p>
                      </li>

                      <li class="par-ul_li">
                        <p class="par-ul_label">持股周期</p>

                        <p class="par-ul_content" v-if="Obj">
                          <span v-for="(item, index) in Obj.holdPeriodList.split(',')" :key="index"
                            >{{ item }}天</span
                          >
                        </p>
                      </li>
                    </ul>
                  </div>
                </van-col>
              </van-row>
            </div>
          </div>

          <div class="btm-style" ref="body">
            <div ref="tabs">
              <van-sticky :offset-top="contentNavBar - 2" z-index="99">
                <van-tabs v-model="active" @change="handleClickTabs">
                  <van-tab title="评级报告"></van-tab>
                  <van-tab title="最新信号"></van-tab>
                  <van-tab title="历史累计收益"></van-tab>
                  <van-tab title="回测分析"></van-tab>
                </van-tabs>
              </van-sticky>
            </div>

            <div id="section1" ref="section1" v-if="Obj">
              <LhPjbg
                :ReportGradeResult="Obj.apiData.ReportGradeResult"
                :startDate="Obj.startDate"
                :endDate="Obj.endDate"
                :RadarMapResult="Obj.apiData.RadarMapResult"
              ></LhPjbg>
            </div>

            <p
              style="background: #f8f9fc; height: 8px"
              :style="$route.query.themeStyleVs == 2 ? 'background:#0B0F14' : ''"
            ></p>

            <div id="section2" ref="section2" v-if="Obj">
              <Zxxg
                :tabsHeight="tabsHeight"
                :headerHeight="contentNavBar"
                :StockPoolsResult="Obj.apiData.StockPoolsResult"
              ></Zxxg>
            </div>

            <p
              style="background: #f8f9fc; height: 8px"
              :style="$route.query.themeStyleVs == 2 ? 'background:#0B0F14' : ''"
            ></p>

            <div id="section3" ref="section3" v-if="Obj">
              <Ljsy
                :tabsHeight="tabsHeight"
                :headerHeight="contentNavBar"
                :Obj="Obj"
                :checkedYzList="checkedYzList"
              ></Ljsy>
            </div>

            <p
              style="background: #f8f9fc; height: 8px"
              :style="$route.query.themeStyleVs == 2 ? 'background:#0B0F14' : ''"
            ></p>

            <div id="section4" ref="section4" v-if="Obj">
              <LhHcfx
                :tabsHeight="tabsHeight"
                :headerHeight="contentNavBar"
                :BacktestAnalysisResult="Obj.apiData.BacktestAnalysisResult"
                :holdPeriodList="Obj.holdPeriodList"
              ></LhHcfx>
            </div>

            <p
              style="background: #f8f9fc; height: 8px"
              :style="$route.query.themeStyleVs == 2 ? 'background:#0B0F14' : ''"
            ></p>

            <LhLsmx
              v-if="Obj"
              :Obj="Obj"
              :checkedYzList="checkedYzList"
              :tabsHeight="tabsHeight"
              :headerHeight="contentNavBar"
            ></LhLsmx>
          </div>
        </div>
        <van-empty v-else class="custom-image" :image="not_data" :description="description5" />
      </div>

      <!-- <div class="bottom-btn">
        <van-button
          style="width: 140px"
          type="info"
          @click="saveHc(0)"
          :loading="loadingHc"
          loading-text="更新中..."
          :disabled="btnDisabled"
          v-if="publicHcID && btnMsg === '更新回测'"
          >更新回测</van-button
        >

        <van-button
          style="width: 140px"
          type="info"
          :disabled="btnDisabled"
          @click="saveHc(1)"
          :loading="loadingHc"
          loading-text="保存中..."
          v-if="(!publicHcID && btnMsg === '保存为回测') || (publicHcID && btnMsg === '保存为回测')"
          >保存为回测</van-button
        >

        <button @click="handleBtmMnjy">开启模拟交易</button>
      </div> -->

      <!-- <van-overlay :show="showoVerlay">
        <div class="wrapper-overlay" @click.stop>
          <van-form @submit="saveMnjy">
            <p class="wrapper-title">创建量化模拟交易</p>

            <p class="wrapper-label">模拟交易名称</p>
            <div class="name">
              <van-field
                v-model="mnjyName"
                autosize
                maxlength="10"
                show-word-limit
                placeholder="请输入模拟名称"
                :rules="[{ required: true, message: '请输入模拟名称' }]"
              />
            </div>
            <p class="wrapper-label">初始化资金</p>
            <div class="c-l-right">
              <van-field v-model="capital" type="digit" label="" />
              <span class="unit">元</span>
            </div>

            <p class="wrapper-label">选定持仓周期</p>
            <div class="c-l-right">
              <p class="imitation-select" @click="showPeriod = true">
                {{ periodValue }}
                <van-icon name="arrow-down" class="arrow-down" />
              </p>
            </div>

            <van-action-sheet v-model="showPeriod">
              <van-picker
                title="选定持仓周期"
                show-toolbar
                :columns="columnsPeriod"
                @confirm="onConfirmPeriod"
                @cancel="onCancelPeriod"
                :default-index="cgzq_defaultIndex"
              />
            </van-action-sheet>

            <div class="wrapper-btn">
              <van-button
                class="left"
                @click="
                  showoVerlay = false;
                  getClientFun();
                "
                native-type="button"
                >取消</van-button
              >
              <van-button
                type="info"
                class="right"
                :loading="loadingMn"
                loading-text="开启中..."
                native-type="submit"
                >开启模拟交易
              </van-button>
            </div>
          </van-form>
        </div>
      </van-overlay> -->
    </div>

    <!-- 没有慧豆时页面显示 -->
    <NotHd v-else></NotHd>

    <takeOut
      :show="takeShow"
      :name="takeName"
      :btnText="takeBtnName"
      type="openMn"
      @cancelBasis="cancelBasis"
      @linkGo="linkGo"
    ></takeOut>
  </div>
</template>

<script>
import { factorArrCheckoutFun } from '@/utils/commonAPI';
import mixin from '@/mixins/index.js';
import LhPjbg from '@/components/details/LhPjbg.vue';
import Zxxg from '@/components/details/Zxxg.vue';
import Ljsy from '@/components/details/Ljsy.vue';
import LhHcfx from '@/components/details/LhHcfx.vue';
import LhLsmx from '@/components/details/LhLsmx.vue';
import {
  initiateLhHc,
  addLhHc,
  updateMyLhHc,
  mockpanelOpen,
  addMyCl,
  updateMyDyzCl
} from '@/api/create.js';
import VueScrollTo from 'vue-scrollto';
import { mapMutations } from 'vuex';
import NotHd from '@/components/notHd/notHd.vue';
import { getClientRedis, getInalysis } from '@/api/index.js';
import { toFixedNum, judgeColor, formtTime } from '@/utils/format';

var Base64 = require('js-base64').Base64;

export default {
  name: 'Lhhc-preview',
  mixins: [mixin],
  data() {
    return {
      is304: false,
      capital: 100000, //初始化资金
      bodyOffsetTop: 0,
      isShowParameterAll: false,
      index_info: 1,
      num: 2,
      active: 0,
      ReportGradeResult: {},
      starDate: '',
      endDate: '',
      BacktestAnalysisResult: [],
      periodArr: [],
      condition: {},
      loadingHc: false,
      loadingMn: false,
      isShowSaveHc: true,
      filterNum: 0,
      tabsHeight: 0,
      showoVerlay: false,
      mnjyName: '',
      clDetails: '',
      section1: 0,
      section1_initialize: 0,
      columnsPeriod: [],
      showPeriod: false,
      periodValue: '',
      MaxRetreatRateIndex: 0,
      cgzq_defaultIndex: 0, //持股周期select默认值
      h_id: null,
      timeoutId: null, // 添加 timeoutId 属性，用于存储 setTimeout 的返回值

      btnMsg: '保存为回测',
      takeShow: false,
      takeName: '',
      takeBtnName: '',
      isShowKd: false,

      checkedYzList: [],
      Obj: null,
      queryResult: true,
      not_data: require('../../assets/image/notData.png'),
      description5: '暂未获取到数据'
    };
  },
  components: {
    LhPjbg,
    Zxxg,
    Ljsy,
    LhHcfx,
    LhLsmx,
    NotHd
  },
  filters: {},
  //计算属性
  computed: {
    contentNavBar: function () {
      return this.$store.state.contentNavBar; // 获取全局状态
    },
    publicHcID: function () {
      return this.$store.state.publicHcID; // 获取vuex的id 要是存在id走编辑逻辑
    },
    btnDisabled: function () {
      return this.$store.state.btnDisabled; // 用来控制回测是变灰还是现实更新
    }
  },
  watch: {
    showoVerlay: function (i) {
      if (i) {
        this.mnjyName = this.Obj.name || '';
        this.clDetails = this.Obj.desc || '';
      } else {
        this.mnjyName = '';
        this.clDetails = '';
      }
    }
  },
  created() {
    // this.getClientFun();
    let that = this;
    that.$toast.loading({
      message: '加载中...',
      overlay: true,
      duration: 0
    });
    let idList = decodeURIComponent(that.getUrlQuery('factorid')).split(',');
    let nameList = decodeURIComponent(that.getUrlQuery('factornames')).split(',');
    let arrData = nameList.map((item, index) => {
      return { FactorName: item, ID: idList[index] };
    });
    that.checkedYzList = arrData;
    let obj = {
      userid: decodeURIComponent(that.getUrlQuery('userid')),
      factorlist: decodeURIComponent(that.getUrlQuery('factorid')),
      startdate: that.formtTime(that.getLastYear(), 'yyyyMMdd'),
      enddate: that.formtTime(that.getLastDay(), 'yyyyMMdd')
    };
    getInalysis(obj)
      .then((res) => {
        if (res.err === 200) {
          let queryObj = {
            factorList: decodeURIComponent(that.getUrlQuery('factorid')), //多因子id
            factorName: decodeURIComponent(that.getUrlQuery('factornames')), //因子池内容名称(多个时用逗号分隔)
            holdPeriodList: res.data.BestParamResult.HoldPeriod + '', //持股周期列表用逗号分割
            startDate: obj.startdate, //回测开始日期
            endDate: obj.enddate, //回测结束日期
            startMoney: res.data.BestParamResult.StartMoney, //初始资金
            PositionLimit: res.data.BestParamResult.PosLimit, //持仓股票数上限
            buyLimit: res.data.BestParamResult.BuyLimit, //单日买入股票数上限
            stopProfitHigh: res.data.BestParamResult.StopProfitHigh, //止盈卖出高水位线
            stopProfitLow: res.data.BestParamResult.StopProfitLow, //止盈卖出低水位线(止盈回撤线)
            stopLoss: res.data.BestParamResult.StopLossRate, // 止损卖出水位线
            sortKind: res.data.BestParamResult.SortKind, //买入排序类型
            sortDirection: res.data.BestParamResult.SortDirection, //排序方向0~1 0:从大到小 1:从小到大
            buyType: 0, //买入方式 0:开盘买入 1:收盘买入
            product: false
          };
          that.getLhHc(queryObj);
        } else {
          that.queryResult = false;
          that.$toast.clear();
        }
      })
      .catch(() => {
        that.queryResult = false;
        that.$toast.clear();
      });
    if (window.DzhAppJs) {
      let obj = {
        navBarHidden: 1,
        titleHidden: 1
      };

      DzhAppJs.callAppWithChannelAndJsonAndCallbackFunc('setTitleStyle', obj, '');
    }
  },
  async mounted() {
    if (this.publicHcID) {
      this.btnMsg = '更新回测';
    } else {
      this.btnMsg = '保存为回测';
    }
    // this.mnjyName = this.Obj.name || '';
    // this.clDetails = this.Obj.desc || '';
    // window.addEventListener('scroll', this.handleScroll);
    // window.addEventListener('scroll', this.handleScrollTab);

    // //获取评级报告和回测分析的高度
    // var contentTabs = this.$refs['tabs'];
    // this.tabsHeight = contentTabs.offsetHeight;

    // this.bodyOffsetTop = this.$refs.body.getBoundingClientRect().top;
    // this.section1_initialize = this.$refs.section1.getBoundingClientRect().top;

    // var day = this.Obj.holdPeriodList.split(',');
    // this.columnsPeriod = day.map((number) => number + '天');
    // var indices = this.getMaxIndices(this.Obj.apiData.BacktestAnalysisResult, 'YearRate');
    // this.MaxRetreatRateIndex = indices.MaxRetreatRateIndex;
    // this.periodValue = this.columnsPeriod[this.MaxRetreatRateIndex];
    // this.capital = this.Obj.startMoney || 100000;
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
    window.removeEventListener('scroll', this.handleScrollTab);
  },
  methods: {
    ...mapMutations(['resetState']),
    toFixedNum,
    judgeColor,
    formtTime,
    //查询是否显示扣豆
    getClientFun() {
      var _this = this;
      getClientRedis({})
        .then((res) => {
          if (res.err === 200) {
            var data = JSON.parse(res.data);
            _this.setLocalData(data);
            if (data.openMn === 'true') {
              _this.isShowKd = false;
            } else {
              _this.isShowKd = true;
            }
          } else {
            _this.isShowKd = true;
            _this.setLocalData();
          }
        })
        .catch(() => {
          _this.isShowKd = true;
          _this.setLocalData();
        });
    },
    //获取最大值YearRate年化收益
    getMaxIndices: function (data, maxYearRateKey) {
      let MaxRetreatRateIndex = 0;
      let MaxRetreatRate = data[0][maxYearRateKey];

      for (let i = 1; i < data.length; i++) {
        if (data[i][maxYearRateKey] > MaxRetreatRate) {
          MaxRetreatRate = data[i][maxYearRateKey];
          MaxRetreatRateIndex = i;
        }
      }

      return {
        MaxRetreatRateIndex
      };
    },
    //监听ref=body的滚滚动条距离用来控制header的背景色显示隐藏
    handleScroll() {
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      this.bodyOffsetTop = this.$refs.body.getBoundingClientRect().top;
      this.section1 = this.$refs.section1.getBoundingClientRect().top;
      this.filterNum = (scrollTop / (this.bodyOffsetTop / 2)).toFixed(2);
    },

    handleScrollTab() {
      if (this.$refs.section1.getBoundingClientRect().top <= this.tabsHeight + this.contentNavBar) {
        this.active = 0;
      }
      if (this.$refs.section2.getBoundingClientRect().top <= this.tabsHeight + this.contentNavBar) {
        this.active = 1;
      }
      if (this.$refs.section3.getBoundingClientRect().top <= this.tabsHeight + this.contentNavBar) {
        this.active = 2;
      }
      if (this.$refs.section4.getBoundingClientRect().top <= this.tabsHeight + this.contentNavBar) {
        this.active = 3;
      }
    },

    scrollToSection(sectionId) {
      VueScrollTo.scrollTo(`#${sectionId}`, 500, {
        offset: -120 // 调整偏移量以适应您的布局
      });
    },

    //手动点击切换的时候清除监听 然后1s之后再次恢复防止滚动和手动点击冲突
    handleClickTabs: function (i) {
      if (this.timeoutId) {
        clearTimeout(this.timeoutId);
      } else {
        window.removeEventListener('scroll', this.handleScrollTab);
      }

      if (i === 0) {
        this.scrollToSection('section1');
      } else if (i === 1) {
        this.scrollToSection('section2');
      } else if (i === 2) {
        this.scrollToSection('section3');
      } else if (i === 3) {
        this.scrollToSection('section4');
      }

      this.timeoutId = setTimeout(() => {
        window.addEventListener('scroll', this.handleScrollTab);
        this.timeoutId = null;
      }, 1500);
    },
    //把里面所有的FactorName放在一个数组里面
    extractFactorNames: function (data) {
      var factorNames = [];

      function recursiveExtract(obj) {
        if (obj && typeof obj === 'object') {
          if (obj.hasOwnProperty('FactorName')) {
            factorNames.push(obj.FactorName);
          }

          for (let key in obj) {
            if (Array.isArray(obj[key])) {
              obj[key].forEach((item) => recursiveExtract(item));
            } else if (typeof obj[key] === 'object') {
              recursiveExtract(obj[key]);
            }
          }
        }
      }

      recursiveExtract(data);

      return factorNames;
    },

    handleClickShowAll: function () {
      if (this.num === 2) {
        this.num = this.checkedYzList.length;
      } else {
        this.num = 2;
      }
    },

    //展示全部/一条交易参数
    handleClickShowParameterAll: function () {
      this.isShowParameterAll = !this.isShowParameterAll;
    },

    //获取id和name
    // extractIdAndFactorName: function (data) {
    //   var ids = [];
    //   var factorNames = [];

    //   data.forEach((item) => {
    //     ids.push(item.ID);
    //     factorNames.push(item.FactorName);
    //   });

    //   return {
    //     ids,
    //     factorNames
    //   };
    // },
    filterData: function (data) {
      var filteredData = [];
      for (var i = 0; i < data.length; i++) {
        var item = data[i];
        var filteredItem = {};
        filteredItem.ID = item.ID;
        filteredItem.FactorName = item.FactorName;
        filteredItem.RiZhangFu = item.RiZhangFu;
        filteredItem.XinHaoShuLiang = item.XinHaoShuLiang;
        filteredItem.yzType = item.yzType;
        filteredData.push(filteredItem);
      }
      return filteredData;
    },
    //点击保存回测按钮
    // saveHc: function (type) {
    //   if (type === 0) {
    //     this.updateMyLhHcFun();
    //   } else if (type === 1) {
    //     this.addLhHcFun();
    //   } else if (type === 2) {
    //     if (this.publicHcID && !this.btnDisabled) {
    //       this.updateMyLhHcFun(2);
    //     } else {
    //       this.addLhHcFun(2);
    //     }
    //   }
    // },
    //保存量化回测
    // addLhHcFun: function (type) {
    //   var _this = this;
    //   _this.loadingHc = true;
    //   return addLhHc({
    //     record_id: _this.Obj.apiData.HashID, //string :"", 回测记录Id
    //     f_id_arr: _this.Obj.factorList, //string :"", 因子id 16进制
    //     f_name_arr: _this.extractIdAndFactorName(_this.checkedYzList).factorNames.toString(), //string :""
    //     chigu_cycle: _this.Obj.holdPeriodList, //持股周期: 1,2,3,4,5,6,99
    //     chigu_type: _this.Obj.isCustomSelected ? 1 : 2, //持股类型: 0默认 1自定义周期 2持股周期
    //     starDate: _this.Obj.startDate, //回测开始时间 : 20220101
    //     endDate: _this.Obj.endDate, //回测结束时间 : 20230101
    //     startMoney: _this.Obj.startMoney, //Int    :"", 初始化资金
    //     posLimit: _this.Obj.PositionLimit, // Int    :"", 持股上限
    //     buyLimit: _this.Obj.buyLimit, // Int    :"", 单日买入数量
    //     buyTiming: 0, // Int    :"", 0:次日开盘买入
    //     buyType: 0, // Int    :"", 买入方式 0:开盘买入 1:收盘买入
    //     sortKind: _this.Obj.sortKind, // Int    :"", 买入排序类型0~70:成交额 1:涨跌幅 2:换手率 3:量比4:总市值 5:流通市值 6:市盈率TTM 7:振幅 :"",
    //     sortDirection: _this.Obj.sortDirection, // Int    :"", 排序方向0~1 0:从大到小 1:从小到大
    //     stopProfitHigh: _this.Obj.stopProfitHigh, // float  :"", 止盈卖出高水位线 eg:0.07就是7%
    //     stopProfitLow: _this.Obj.stopProfitLow, // float  :"", 止盈卖出低水位线(止盈回撤线) eg:0.01就是1%
    //     stopLoss: _this.Obj.stopLoss, // float  :"", 止损卖出水位线 eg:-0.05就是-5%
    //     MaxYearProfit: _this.Obj.apiData.ReportGradeResult.MaxYearProfit, //-0.877946, // 预估年化收益
    //     MaxYearCycle: _this.Obj.apiData.ReportGradeResult.MaxYearCycle, //2, // 预估年化收益对应的持股周期
    //     MaxSuccessRate: _this.Obj.apiData.ReportGradeResult.MaxSuccessRate, //0.4629, // 最大成功率
    //     MaxSuccessCycle: _this.Obj.apiData.ReportGradeResult.MaxSuccessCycle, //2, // 最大成功率对应的持股周期
    //     MaxRetreatRate: _this.Obj.apiData.ReportGradeResult.MaxRetreatRate, //0.87854, // 当前最大回撤率
    //     MaxRetreatCycle: _this.Obj.apiData.ReportGradeResult.MaxRetreatCycle, //2, // 当前最大回撤率对应的持股周期
    //     collection_condition: 'null', //条件JSON
    //     collection_type: 3, //交并集状态: 0没有交并集 1交集组合 2 并集组合
    //     collection_info: _this.extractIdAndFactorName(_this.checkedYzList).ids.toString() //id,id,id,id
    //   })
    //     .then((res) => {
    //       _this.loadingHc = false;
    //       _this.$toast(res.msg);
    //       if (res.err === 200) {
    //         _this.h_id = res.data.h_id;
    //         _this.$store.commit('setPublicHcID', res.data.h_id);
    //         _this.$store.commit('setBtnDisabled', true);
    //         if (type === 2) {
    //           _this.mockpanelOpenFun();
    //         }
    //       }
    //     })
    //     .catch((err) => {
    //       _this.$toast(err);
    //       _this.loadingHc = false;
    //     });
    // },
    //更新量化回测
    // updateMyLhHcFun: function (type) {
    //   var _this = this;
    //   _this.loadingHc = true;
    //   return updateMyLhHc({
    //     h_id: _this.publicHcID, //string :"", 回测id(客户端生成)
    //     record_id: _this.Obj.apiData.HashID, //string :"", 回测记录Id
    //     f_id_arr: _this.Obj.factorList, //string :"", 因子id 16进制
    //     f_name_arr: _this.extractIdAndFactorName(_this.checkedYzList).factorNames.toString(), //string :""
    //     chigu_cycle: _this.Obj.holdPeriodList, //持股周期: 1,2,3,4,5,6,99
    //     chigu_type: _this.Obj.isCustomSelected ? 1 : 2, //持股类型: 0默认 1自定义周期 2持股周期
    //     starDate: _this.Obj.startDate, //回测开始时间 : 20220101
    //     endDate: _this.Obj.endDate, //回测结束时间 : 20230101
    //     startMoney: _this.Obj.startMoney, //Int    :"", 初始化资金
    //     posLimit: _this.Obj.PositionLimit, // Int    :"", 持股上限
    //     buyLimit: _this.Obj.buyLimit, // Int    :"", 单日买入数量
    //     buyTiming: 0, // Int    :"", 0:次日开盘买入
    //     buyType: 0, // Int    :"", 买入方式 0:开盘买入 1:收盘买入
    //     sortKind: _this.Obj.sortKind, // Int    :"", 买入排序类型0~70:成交额 1:涨跌幅 2:换手率 3:量比4:总市值 5:流通市值 6:市盈率TTM 7:振幅 :"",
    //     sortDirection: _this.Obj.sortDirection, // Int    :"", 排序方向0~1 0:从大到小 1:从小到大
    //     stopProfitHigh: _this.Obj.stopProfitHigh, // float  :"", 止盈卖出高水位线 eg:0.07就是7%
    //     stopProfitLow: _this.Obj.stopProfitLow, // float  :"", 止盈卖出低水位线(止盈回撤线) eg:0.01就是1%
    //     stopLoss: _this.Obj.stopLoss, // float  :"", 止损卖出水位线 eg:-0.05就是-5%
    //     MaxYearProfit: _this.Obj.apiData.ReportGradeResult.MaxYearProfit, //-0.877946, // 预估年化收益
    //     MaxYearCycle: _this.Obj.apiData.ReportGradeResult.MaxYearCycle, //2, // 预估年化收益对应的持股周期
    //     MaxSuccessRate: _this.Obj.apiData.ReportGradeResult.MaxSuccessRate, //0.4629, // 最大成功率
    //     MaxSuccessCycle: _this.Obj.apiData.ReportGradeResult.MaxSuccessCycle, //2, // 最大成功率对应的持股周期
    //     MaxRetreatRate: _this.Obj.apiData.ReportGradeResult.MaxRetreatRate, //0.87854, // 当前最大回撤率
    //     MaxRetreatCycle: _this.Obj.apiData.ReportGradeResult.MaxRetreatCycle, //2, // 当前最大回撤率对应的持股周期
    //     collection_condition: 'null', //条件JSON
    //     collection_type: 3, //交并集状态: 0没有交并集 1交集组合 2 并集组合
    //     collection_info: _this.extractIdAndFactorName(_this.checkedYzList).ids.toString() //id,id,id,id
    //   })
    //     .then((res) => {
    //       _this.loadingHc = false;
    //       _this.$toast(res.msg);
    //       if (res.err === 200) {
    //         _this.$store.commit('setBtnDisabled', true);
    //         if (type === 2) {
    //           _this.mockpanelOpenFun();
    //         }
    //       }
    //     })
    //     .catch((err) => {
    //       _this.$toast(err);
    //       _this.loadingHc = false;
    //     });
    // },
    //点击开启模拟交易
    // saveMnjy: function () {
    //   if (this.capital < 100000 || this.capital === '') {
    //     this.$toast('初始化资金不能小于10万');
    //     return false;
    //   } else if (this.capital > 10000000) {
    //     this.$toast('初始化资金不能大于1000万');
    //     return false;
    //   } else if (this.capital.toString().startsWith('0')) {
    //     this.$toast('初始化资金输入格式不正确');
    //     return false;
    //   }

    //   if (this.publicHcID && this.btnDisabled) {
    //     this.mockpanelOpenFun();
    //   } else {
    //     this.saveHc(2);
    //   }
    // },

    // handleBtmMnjy: function () {
    //   let msg = [];
    //   factorArrCheckoutFun(this.Obj.factorList).then((d) => {
    //     if (d.length > 0) {
    //       d.forEach((i) => {
    //         if (i.BacktestType == 2 || i.BacktestType == 3) {
    //           msg.push(i.Name + '(不可回测)');
    //         } else if (i.BacktestType == 10) {
    //           msg.push(i.Name + '(已删除)');
    //         }
    //       });

    //       this.$toast('开启模拟交易失败:' + msg.toString());
    //     } else {
    //       if (this.isShowKd) {
    //         this.takeName = '每次开启模拟交易需消耗 2个慧豆';
    //         this.takeBtnName = '继续开启';
    //         this.takeShow = true;
    //         return false;
    //       }
    //       this.showoVerlay = true;
    //       this.cgzq_defaultIndex = this.findIndexFromList(
    //         this.periodValue.replace('天', ''),
    //         this.columnsPeriod
    //       );
    //     }
    //   });
    // },

    // findIndexFromList: function (value, list) {
    //   const valueString = value + '天';
    //   for (let i = 0; i < list.length; i++) {
    //     if (list[i] === valueString) {
    //       return i;
    //     }
    //   }

    //   return 0; // 如果未找到匹配值，则返回 0 表示未找到
    // },
    cancelBasis: function () {
      this.takeShow = false;
    },

    linkGo: function () {
      this.takeShow = false;
      this.showoVerlay = true;
    },

    //开启模拟交易
    // mockpanelOpenFun: function () {
    //   let _this = this;

    //   _this.loadingMn = true;

    //   var params = {
    //     name: _this.mnjyName, //模拟盘名称
    //     cycle: _this.periodValue.replace('天', ''), // 选择的持股周期
    //     startMoney: _this.capital, //初始资金
    //     h_id: _this.h_id || _this.publicHcID //选中的回测ID
    //   };
    //   return mockpanelOpen(params)
    //     .then((res) => {
    //       _this.loadingMn = false;
    //       _this.$toast(res.msg);
    //       if (res.err === 200) {
    //         _this.showoVerlay = false;

    //         var url = `${
    //           _this.getBaseUrl() +
    //           '/mnDetail?token=' +
    //           _this.$route.query.token +
    //           '&zj_id=' +
    //           res.data.zj_id +
    //           '&DZHSPECIAL=4325641'
    //         }`;

    //         window.location.href = `dzh_browser_url&goto=0&screen=263&nextUrl=${Base64.encode(
    //           url
    //         )}`;
    //         setTimeout(() => {
    //           _this.resetState(); //重置部分vuex
    //         }, 500);
    //       } else if (res.err === 304) {
    //         _this.is304 = true;
    //         window.location.href = window.config.hdTips;
    //       } else if (res.err === 305) {
    //         _this.$toast('功能使用异常，请检查您的登录状态');
    //       }
    //     })
    //     .catch((err) => {
    //       _this.loadingMn = false;
    //       _this.$toast(err);
    //     });
    // },

    //持仓周期
    // onConfirmPeriod: function (value, index) {
    //   this.showPeriod = false;
    //   this.periodValue = value;
    // },

    // onCancelPeriod: function (picker, value, index) {
    //   this.showPeriod = false;
    // },
    close: function () {
      location.href = 'dzh_browser_url&goto=0&screen=263';
    },
    // 请求回测 (量化交易)
    getLhHc: function (obj) {
      let that = this;
      var params = {
        factorList: obj.factorList, //string 因子列表
        holdPeriodList: obj.holdPeriodList, //string 持股周期: 1,2,3,4,5,6
        startDate: obj.startDate, //string 开始时间 : 20220101
        endDate: obj.endDate, //string 结束时间 : 20230101
        startMoney: obj.startMoney, //初始资金
        PositionLimit: obj.PositionLimit, //持仓股票数上限
        buyLimit: obj.buyLimit, //单日买入股票数上限
        sortKind: obj.sortKind, //买入排序类型0~70:成交额 1:涨跌幅 2:换手率 3:量比4:总市值 5:流通市值 6:市盈率TTM 7:振幅
        sortDirection: obj.sortDirection, //排序方向0~1 0:从大到小 1:从小到大
        stopProfitHigh: obj.stopProfitHigh, //止盈卖出高水位线 eg:0.07就是7%
        stopProfitLow: obj.stopProfitLow, //止盈卖出低水位线(止盈回撤线) eg:0.01就是1%
        stopLoss: obj.stopLoss, //止损卖出水位线 eg:-0.05就是-5%
        buyType: obj.buyType, //买入方式 0:开盘买入 1:收盘买入
        product: false // 与客户端联调时放开 [超参寻优 : true  (选填)]
      };
      initiateLhHc(params)
        .then((res) => {
          if (res.err === 200) {
            obj.apiData = res.data;
            that.Obj = obj;
            that.$nextTick(function () {
              that.section1_initialize = that.$refs.section1.getBoundingClientRect().top;
              that.mnjyName = that.Obj.name || '';
              that.clDetails = that.Obj.desc || '';
              window.addEventListener('scroll', that.handleScroll);
              window.addEventListener('scroll', that.handleScrollTab);
              //获取评级报告和回测分析的高度
              var contentTabs = that.$refs['tabs'];
              that.tabsHeight = contentTabs.offsetHeight;
              that.bodyOffsetTop = that.$refs.body.getBoundingClientRect().top;
            });
          } else {
            that.queryResult = false;
          }
          that.$toast.clear();
        })
        .catch((err) => {
          console.log(err);
          that.queryResult = false;
          that.$toast.clear();
        });
    }
  }
};
</script>
<style lang="less" scoped>
.showParameterAll_animation {
  animation: flip-horizontal-top 0.4s cubic-bezier(0.455, 0.03, 0.515, 0.955) both;
}

@keyframes flip-horizontal-top {
  0% {
    transform: rotateX(180deg);
  }
  100% {
    transform: rotateX(360deg);
  }
}

.yulan-info {
  .header-bg {
    height: 100vh;
  }

  @keyframes fadeInOut {
    0% {
      opacity: 0.5;
    }
    50% {
      opacity: 0.8;
    }
    100% {
      opacity: 1;
    }
  }
  .header {
    padding: 20px 16px;
    .title {
      display: flex;
      align-items: center;
      justify-content: space-between;
      .name {
        font-weight: 500;
        font-size: 20px;
        color: #222;
      }
      .edit {
        width: 60px;
        height: 30px;
        background: #286df7;
        border-radius: 4px;
        font-weight: 500;
        font-size: 14px;
        color: #fff;
      }
    }
  }
  .collapse {
    padding: 0 16px 22px 16px;
    .title {
      font-weight: 700;
      font-size: 14px;
      color: #286df7;
    }
    .yz-list {
      .li {
        height: 34px;
        line-height: 34px;
        border: 1px solid #fff;
        border-radius: 4px;
        background: linear-gradient(to bottom right, #e6edff 10%, #fff 60%);
        padding: 0 12px;
        margin-top: 6px;
        font-weight: 500;
        font-size: 12px;
        color: rgba(55, 58, 77, 0.9);
      }
    }
    .parameter {
      .li {
        display: flex;
        height: auto;
        line-height: normal;
        padding: 10px 12px;
        .par-classify {
          font-size: 14px;
          font-weight: 700;
          background: linear-gradient(90deg, rgba(35, 134, 234, 1), rgba(67, 106, 206, 1));
          -webkit-background-clip: text; /* Safari/Chrome */
          -webkit-text-fill-color: transparent; /* Safari/Chrome */
          background-clip: text; /* 其他浏览器 */
          color: transparent;
          margin-right: 26px;
        }

        .par-ul {
          line-height: 20px;
          .par-ul_li {
            display: flex;
            align-items: center;
            .par-ul_label {
              color: #666;
              font-size: 12px;
              font-weight: 400;
              width: 80px;
              flex-shrink: 0;
            }
            .par-ul_content {
              color: rgba(55, 58, 77, 0.9);
              font-size: 12px;
              font-weight: bold;
            }
          }
        }
      }
    }
  }
  .btm-style {
    border-radius: 8px 8px 0 0;
    background: #fff;
    // padding-bottom: 80px;
  }
  .yulan-content {
    .van-tabs {
      border-radius: 8px 8px 0 0;
      overflow: hidden;
    }
    ::v-deep {
      .van-sticky {
        // padding: 0 12px;
      }
      .van-tab {
        font-weight: 400;
        font-size: 14px;
        color: #373a4d;
        padding: 0;
      }
      .van-tab--active {
        font-weight: 600 !important;
        font-size: 14px !important;
        color: #286df7 !important;
      }
      .van-tabs__line {
        background: #286df7;
      }
    }
  }
  .bottom-btn {
    position: fixed;
    bottom: 34px;
    width: 100%;
    padding: 0 18.5px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    z-index: 9;

    button {
      border: none;
      &:first-child {
        height: 40px;
        border-radius: 20px;
        padding: 0px 16px;
        background: #fff;
        border: 1px solid #286df7;
        color: #286df7;
        width: 120px;
        flex-shrink: 0;
        margin-right: 8px;
      }
      &:last-child {
        height: 40px;
        border-radius: 20px;
        padding: 0px 16px;
        background: #286df7;
        border: 1px solid #286df7;
        color: #fff;
        width: 100%;
      }
    }
  }
  ::v-deep {
    .wrapper-btn {
      display: flex;
      align-items: center;
      justify-content: space-between;
      button {
        border: none;
        height: 36px;
        font-size: 14px;
        border-radius: 6px;
        width: 50%;
      }
      .left {
        background: #f5f5f6;
        color: #222;
        margin-right: 12px;
      }
      .rught {
        background: #286df7;
        color: #fff;
        margin-left: 12px;
      }
    }
  }
}

::v-deep {
  .van-overlay {
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 100;
    .wrapper-overlay {
      width: 285px;
      border-radius: 10px;
      padding: 16px;
      background: #fff;
      .wrapper-title {
        text-align: center;
        font-size: 16px;
        color: #222;
        margin-bottom: 16px;
      }
      .wrapper-label {
        font-size: 14px;
        color: #555;
        margin-bottom: 4px;
      }
      .c-l-right {
        position: relative;
        display: flex;
        align-items: center;
        .van-cell {
          padding: 8px;
        }

        .unit {
          position: absolute;
          top: 11px;
          right: 8px;
          background: #fff;
        }
        .imitation-select {
          margin-bottom: 17px;
          width: 100%;
          position: relative;
          border-radius: 4px;
          height: 38px;
          display: flex;
          align-items: center;
          border: 0.5px solid #e5e5e5;
          padding: 0 8px;
          .arrow-down {
            position: absolute;
            font-size: 15px;
            right: 7px;
            top: 11px;
          }
        }
        .mrsj-button {
          width: 120px;
          height: 32px;
          display: flex;
          align-items: center;
          padding: 0 22px 0 12px;
          border-radius: 6px;
          background: #f7f7fc;
          color: #999;
          font-size: 14px;
        }
        .text {
          flex-shrink: 0;
        }
      }
      .name {
        position: relative;
        .van-cell {
          height: 38px;
          padding: 8px 10px;
        }
        .van-field__word-limit {
          position: absolute;
          right: 7px;
          top: 0px;
        }
      }
      .van-cell {
        border: 0.5px solid #e5e5e5;
        border-radius: 4px;
        margin-bottom: 16px;
        &::after {
          border: none;
        }
      }
      .van-field__control {
        &::placeholder {
          font-size: 14px;
        }
      }
    }
    .wrapper-btn {
      display: flex;
      align-items: center;
      justify-content: space-between;
      button {
        border: none;
        height: 36px;
        font-size: 14px;
        border-radius: 6px;
        width: 50%;
      }
      .left {
        background: #f5f5f6;
        color: #222;
        margin-right: 12px;
      }
      .rught {
        background: #286df7;
        color: #fff;
        margin-left: 12px;
      }
    }
  }
}
</style>

<!-- 黑色主题 -->
<style lang="less" scoped>
.black_theme {
  .yulan-content {
    .name,
    .title {
      color: #e4e9fe !important;
    }
    .yz-list {
      .li {
        border: 1px solid rgba(255, 255, 255, 0.1);
        background: rgba(255, 255, 255, 0.1);
        color: #e4e9fe;
        .par-classify {
          background: linear-gradient(90deg, #e4e9fe, #e4e9fe);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
          color: transparent;
        }
        .par-ul {
          .par-ul_li {
            .par-ul_label {
              color: #aab9d1;
            }
            .par-ul_content {
              color: #e4e9fe;
            }
          }
        }
      }
    }
    ::v-deep {
      .btm-style,
      .van-tabs__nav {
        background: #191a24;
      }
      .van-tab {
        color: #e4e9fe;
      }
    }
  }
  .wrapper-overlay {
    background: #181a23 !important;
    .unit {
      background: #191a24 !important;
      color: #aab9d1 !important;
    }
    .wrapper-title {
      color: #e4e9fe !important;
    }
    .wrapper-label {
      color: #aab9d1 !important;
    }
    .van-cell {
      background: none;
      border: 1px solid #3b3d43 !important;
    }
    ::v-deep {
      .van-field__control {
        color: #e4e9fe !important;
      }
      .imitation-select {
        color: #e4e9fe !important;
        background: none;
        border: 1px solid #3b3d43 !important;
      }
    }
    .wrapper-btn {
      .left {
        background: #46484f;
        color: #aab9d1;
      }
    }
  }
  .bottom-btn {
    button {
      &:first-child {
        background: #46484f;
        border: 1px solid #46484f;
        color: #e4e9fe;
      }
    }
    .van-button--disabled {
      background: #25262a !important;
      border: 1px solid #25262a !important;
      color: #e4e9fe !important;
    }
  }
}
</style>
